module.exports = __webpack_public_path__ + "static/JHFinanace_logo.75d53e1b.png";